import { useSession } from "../providers/Session/useSession";

export const entitlementsQueryKeys = {
  all: ["entitlements"] as const,
};

/**
 * Returns the entitlements and element roles from the session context.
 *
 * The actual query is owned by SessionProvider so it runs exactly once.
 * This hook is a convenience wrapper — call sites can also read
 * `useSession().entitlements` directly.
 */
export function useEntitlements() {
  const { entitlements, elementRoles, isLoading } = useSession();

  return {
    data: entitlements,
    elementRoles,
    isLoading: isLoading,
  } as const;
}
